export const faqItems = [
  {
    question: '51吃瓜在线是什么？',
    answer: '51吃瓜在线是国内领先的娱乐资讯聚合平台，汇集全网最新、最热的吃瓜爆料内容。无论是明星动态、网红八卦还是综艺剧透，这里都能第一时间掌握第一手信息，是吃瓜群众不可错过的聚集地。',
  },
  {
    question: '如何获取51吃瓜在线最新网址入口？',
    answer: '由于网络环境变化，51吃瓜在线网址可能会不定期更新。建议收藏本站首页，我们会实时同步最新可用地址，同时提供手机版适配入口和官方APP下载渠道，确保你随时随地都能顺利访问平台。',
  },
  {
    question: '51吃瓜在线的内容更新频率如何？',
    answer: '平台保持7×24小时不间断更新，编辑团队全天候追踪全网热点。从突发事件到深度扒料，每条内容都经过多源交叉验证，确保信息时效性与可信度兼顾，让你不错过任何一个吃瓜机会。',
  },
  {
    question: '手机端如何使用51吃瓜在线？',
    answer: '51吃瓜在线已全面适配移动端访问，你可以通过手机浏览器直接打开最新网址体验完整功能，也可下载官方APP享受更流畅的浏览体验和推送通知服务，随时随地掌握热瓜动态。',
  },
];

export const updateItems = [
  {
    time: '10分钟前',
    tag: '热',
    title: '某顶流男星被拍到深夜密会，工作室火速发声明否认',
    summary: '网友曝光多角度实拍图，细节丰富引发全网讨论',
  },
  {
    time: '28分钟前',
    tag: '新',
    title: '热门综艺录制现场突发状况，导演组紧急调整赛制',
    summary: '现场观众透露录制中断近两小时，选手情绪波动明显',
  },
  {
    time: '1小时前',
    tag: '爆',
    title: '知名带货主播被质疑产品虚假宣传，品牌方连夜回应',
    summary: '第三方检测报告流出，涉事商品已紧急下架处理',
  },
  {
    time: '2小时前',
    tag: '热',
    title: '大热影视CP被曝戏外不和，片场路透图持续流出',
    summary: '双方粉丝在社交平台激烈交锋，话题阅读量破5亿',
  },
  {
    time: '3小时前',
    tag: '新',
    title: '音乐节阵容官宣前夕遭泄露，主办方表示将追责',
    summary: '泄露名单含多位重量级艺人，网友直呼阵容太豪华',
  },
  {
    time: '5小时前',
    tag: '热',
    title: '说唱歌手新专辑歌词引争议，多位艺人公开发声',
    summary: '社交平台话题持续发酵，相关讨论帖超10万条',
  },
  {
    time: '7小时前',
    tag: '新',
    title: '影视公司老板离婚案开庭，财产分割成焦点',
    summary: '涉及多部待上映作品版权归属，行业关注度极高',
  },
  {
    time: '9小时前',
    tag: '爆',
    title: '热门游戏主播合约纠纷升级，平台发布官方声明',
    summary: '违约金数额惊人，双方各执一词互不相让',
  },
  {
    time: '12小时前',
    tag: '新',
    title: '知名导演新片选角引发热议，多位演员试镜路透曝光',
    summary: '网友自发推选心仪人选，讨论热度持续攀升',
  },
];

export const cardItems = [
  {
    title: '某顶流爱豆被爆隐婚三年，妻子竟是圈外人',
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20gossip%20breaking%20news%20concept%20with%20warm%20dramatic%20lighting%2C%20mysterious%20silhouette%20on%20magazine%20cover%20style%2C%20soft%20golden%20tones%2C%20editorial%20photography%2C%20clean%20composition%20with%20subtle%20grain%20texture&width=600&height=400&seq=card-01&orientation=landscape',
    tag: '重磅爆料',
    excerpt: '知情人士透露两人已育有一子，社交账号私密动态被扒出大量线索',
    stat: '阅读 128万',
  },
  {
    title: '综艺录制黑幕录音曝光，节目组涉嫌操控投票',
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20TV%20show%20production%20controversy%2C%20dramatic%20studio%20lighting%20with%20warm%20amber%20tones%2C%20mysterious%20atmosphere%2C%20editorial%20style%20with%20soft%20shadows%2C%20cinematic%20composition&width=600&height=400&seq=card-02&orientation=landscape',
    tag: '独家',
    excerpt: '前工作人员勇敢揭露内幕，公开录音内容令人震惊，引发行业震动',
    stat: '阅读 203万',
  },
  {
    title: '知名女星生日派对豪华阵容曝光，半个娱乐圈到场',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20celebrity%20party%20atmosphere%20with%20warm%20golden%20ambient%20lighting%2C%20elegant%20event%20decor%2C%20soft%20bokeh%20background%2C%20editorial%20photography%20style%2C%20sophisticated%20evening%20scene&width=600&height=400&seq=card-03&orientation=landscape',
    tag: '热点',
    excerpt: '派对选址海外私人庄园，到场嘉宾阵容堪比颁奖典礼红毯',
    stat: '阅读 96万',
  },
  {
    title: '热门剧集番位之争白热化，男女主角互相取关',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20industry%20conflict%20concept%2C%20split%20screen%20composition%20with%20warm%20and%20cool%20contrast%2C%20cinematic%20lighting%2C%20editorial%20style%2C%20film%20noir%20aesthetic&width=600&height=400&seq=card-04&orientation=landscape',
    tag: '追剧必看',
    excerpt: '剧方迟迟未公布番位排序，粉丝应援大战一触即发',
    stat: '阅读 167万',
  },
  {
    title: '短视频平台头部网红塌房，代言品牌纷纷解约',
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20influencer%20controversy%20concept%2C%20dramatic%20falling%20brand%20logos%20in%20warm%20artistic%20composition%2C%20soft%20cinematic%20lighting%2C%20editorial%20photography%2C%20moody%20atmosphere&width=600&height=400&seq=card-05&orientation=landscape',
    tag: '塌房现场',
    excerpt: '私生活混乱被实锤，千万粉账号一夜掉粉超百万',
    stat: '阅读 341万',
  },
  {
    title: '实力派演员转型导演首作口碑爆棚，票房逆袭',
    image: 'https://readdy.ai/api/search-image?query=Film%20director%20debut%20success%20concept%2C%20cinema%20screen%20with%20warm%20golden%20light%2C%20movie%20premiere%20atmosphere%2C%20editorial%20photography%2C%20elegant%20composition%20with%20film%20grain&width=600&height=400&seq=card-06&orientation=landscape',
    tag: '影视',
    excerpt: '首周末票房突破三亿，观众评价真诚动人，有望冲击年度黑马',
    stat: '阅读 89万',
  },
  {
    title: '国际音乐颁奖礼华人歌手斩获大奖，创造历史',
    image: 'https://readdy.ai/api/search-image?query=Music%20awards%20ceremony%20stage%20with%20warm%20spotlight%20and%20golden%20confetti%2C%20triumphant%20moment%2C%20editorial%20photography%20style%2C%20cinematic%20lighting%2C%20elegant%20composition&width=600&height=400&seq=card-07&orientation=landscape',
    tag: '骄傲',
    excerpt: '获奖感言感动全场，用中文致谢引发海外媒体广泛报道',
    stat: '阅读 215万',
  },
];

export const indexItems = [
  { title: '明星八卦', icon: 'ri-star-line', count: '128条', desc: '最新明星动态与独家爆料' },
  { title: '综艺追剧', icon: 'ri-tv-line', count: '96条', desc: '热门综艺与影视剧透汇总' },
  { title: '网红圈', icon: 'ri-live-line', count: '85条', desc: '短视频平台网红热点追踪' },
  { title: '音乐现场', icon: 'ri-music-line', count: '62条', desc: '演唱会与音乐节最新消息' },
  { title: '时尚穿搭', icon: 'ri-shirt-line', count: '54条', desc: '明星红毯与日常穿搭解读' },
  { title: '电竞游戏', icon: 'ri-gamepad-line', count: '73条', desc: '电竞圈赛事与主播动态' },
  { title: '电影票房', icon: 'ri-film-line', count: '41条', desc: '院线新片与票房数据跟踪' },
  { title: '海外瓜田', icon: 'ri-global-line', count: '39条', desc: '国际娱乐圈新鲜事搬运' },
];

export const topicItems = [
  { name: '#某男星恋情曝光', heat: '983万', rank: 1, trend: 'up' },
  { name: '#综艺黑幕', heat: '876万', rank: 2, trend: 'up' },
  { name: '#新剧定档', heat: '765万', rank: 3, trend: 'new' },
  { name: '#网红翻车', heat: '654万', rank: 4, trend: 'down' },
  { name: '#音乐颁奖礼', heat: '543万', rank: 5, trend: 'up' },
  { name: '#离婚风波', heat: '432万', rank: 6, trend: 'new' },
  { name: '#新歌发布', heat: '398万', rank: 7, trend: 'up' },
  { name: '#片场路透', heat: '356万', rank: 8, trend: 'new' },
  { name: '#品牌代言', heat: '312万', rank: 9, trend: 'down' },
  { name: '#综艺录制', heat: '287万', rank: 10, trend: 'up' },
  { name: '#粉丝应援', heat: '254万', rank: 11, trend: 'new' },
];

export const contactInfo = {
  title: '投稿爆料',
  description: '你手握独家猛料吗？发现身边的大事小情想与千万吃瓜群众分享？51吃瓜在线开放投稿通道，欢迎向我们提供线索，爆料一经采用即付丰厚稿酬。你的身份将严格保密，安全可靠。',
  email: 'tips@51chigua.example.com',
  wechat: 'chigua51kefu',
  tip: '投稿请附详细事件描述与相关证据材料',
};

export const featureItems = [
  {
    icon: 'ri-flashlight-line',
    title: '极速追踪',
    desc: '7×24小时全网热点监控，突发事件秒级推送，让你永远快人一步掌握最新瓜情',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全访问',
    desc: '多重加密技术保障浏览安全，定期更新入口地址，确保访问稳定不中断',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '完美兼容PC端、手机端与平板设备，提供APP下载与移动网页两种便捷访问方式',
  },
  {
    icon: 'ri-team-line',
    title: '海量用户',
    desc: '汇聚千万吃瓜群众，评论区大神云集，深度扒料与趣味解读并存',
  },
  {
    icon: 'ri-file-search-line',
    title: '深度挖掘',
    desc: '专业编辑团队深度调研，多源交叉验证，为你呈现最真实完整的瓜情全貌',
  },
];

export const rankingItems = [
  { rank: 1, title: '顶流男星深夜密会神秘女子，工作室紧急公关', heat: '1,283万', change: 'new' },
  { rank: 2, title: '热门综艺录制黑幕录音曝光引轩然大波', heat: '1,067万', change: 'up' },
  { rank: 3, title: '知名女主播塌房，代言品牌连夜解约', heat: '954万', change: 'up' },
  { rank: 4, title: '影视CP戏外不和实锤，双方互取关社交账号', heat: '876万', change: 'down' },
  { rank: 5, title: '国际音乐颁奖礼华人歌手创造历史', heat: '743万', change: 'up' },
  { rank: 6, title: '实力派演员转型导演首作票房逆袭', heat: '621万', change: 'new' },
  { rank: 7, title: '知名导演新片选角引发全网推选热潮', heat: '598万', change: 'up' },
];

export const mediaItems = [
  {
    title: '独家专访：顶流艺人首次回应近期争议',
    image: 'https://readdy.ai/api/search-image?query=Celebrity%20exclusive%20interview%20studio%20setup%20with%20warm%20dramatic%20lighting%2C%20professional%20video%20production%20atmosphere%2C%20soft%20golden%20tones%2C%20cinematic%20composition%2C%20editorial%20photography%20style&width=800&height=450&seq=media-01&orientation=landscape',
    duration: '15:28',
    views: '892万',
  },
  {
    title: '吃瓜复盘：本月十大热门事件深度解析',
    image: 'https://readdy.ai/api/search-image?query=News%20recap%20montage%20concept%20with%20warm%20vibrant%20colors%2C%20entertainment%20headlines%20collage%20style%2C%20soft%20cinematic%20lighting%2C%20editorial%20photography%2C%20dynamic%20composition&width=800&height=450&seq=media-02&orientation=landscape',
    duration: '22:05',
    views: '567万',
  },
  {
    title: '红毯直击：颁奖礼后台那些不为人知的故事',
    image: 'https://readdy.ai/api/search-image?query=Red%20carpet%20behind%20the%20scenes%20atmosphere%20with%20warm%20glamorous%20lighting%2C%20celebrity%20event%20photography%20style%2C%20soft%20golden%20bokeh%2C%20editorial%20composition%2C%20elegant%20evening%20scene&width=800&height=450&seq=media-03&orientation=landscape',
    duration: '18:42',
    views: '734万',
  },
];

export const carouselItems = [
  {
    title: '年度吃瓜报告：今年最炸裂的十大娱乐事件',
    image: 'https://readdy.ai/api/search-image?query=Year%20in%20review%20entertainment%20news%20concept%20with%20warm%20dramatic%20spotlight%20on%20stage%2C%20golden%20and%20amber%20tones%2C%20cinematic%20atmosphere%2C%20editorial%20photography%2C%20magazine%20cover%20style&width=1200&height=500&seq=carousel-01&orientation=landscape',
    label: '年终盘点',
    excerpt: '从顶流塌房到黑马逆袭，回顾今年那些让吃瓜群众彻夜不眠的热门话题',
    stat: '阅读 2,567万',
  },
  {
    title: '深度调查：娱乐圈背后的资本暗流与利益链',
    image: 'https://readdy.ai/api/search-image?query=Investigative%20journalism%20concept%20with%20warm%20dramatic%20lighting%2C%20mysterious%20corporate%20boardroom%20atmosphere%2C%20golden%20and%20deep%20amber%20tones%2C%20cinematic%20composition%2C%20film%20noir%20style&width=1200&height=500&seq=carousel-02&orientation=landscape',
    label: '深度专题',
    excerpt: '揭开娱乐圈光鲜表面下的资本运作真相，透视明星与资本之间的微妙关系',
    stat: '阅读 1,893万',
  },
  {
    title: '新星崛起：2026年最值得关注的十位潜力艺人',
    image: 'https://readdy.ai/api/search-image?query=Rising%20stars%20spotlight%20concept%2C%20young%20talented%20performers%20in%20warm%20golden%20stage%20lighting%2C%20cinematic%20atmosphere%2C%20editorial%20photography%20style%2C%20elegant%20composition&width=1200&height=500&seq=carousel-03&orientation=landscape',
    label: '星势力',
    excerpt: '从新人演员到独立音乐人，盘点那些正在改写娱乐圈格局的新鲜血液',
    stat: '阅读 1,456万',
  },
  {
    title: '吃瓜指南：如何辨别真假爆料与谣言陷阱',
    image: 'https://readdy.ai/api/search-image?query=Fake%20news%20detection%20concept%2C%20magnifying%20glass%20over%20newspaper%20with%20warm%20dramatic%20lighting%2C%20editorial%20photography%20style%2C%20cinematic%20composition%2C%20intellectual%20atmosphere&width=1200&height=500&seq=carousel-04&orientation=landscape',
    label: '吃瓜秘籍',
    excerpt: '资深编辑教你识别网络谣言，理性吃瓜不盲目，做最清醒的吃瓜群众',
    stat: '阅读 987万',
  },
];

export const commentItems = [
  {
    user: '吃瓜不嫌事大',
    avatar: 'https://readdy.ai/api/search-image?query=Anonymous%20user%20avatar%20watermelon%20slice%20icon%20on%20warm%20minimal%20background%2C%20flat%20illustration%20style%2C%20clean%20design&width=100&height=100&seq=avatar-01&orientation=squarish',
    time: '3分钟前',
    content: '这个瓜保熟吗？现在信息太杂了，还好有51吃瓜在线帮忙梳理，每天必刷！',
    likes: 326,
  },
  {
    user: '深夜吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Anonymous%20user%20avatar%20night%20owl%20with%20warm%20moon%20icon%2C%20flat%20minimal%20illustration%20style%2C%20clean%20design%20on%20dark%20warm%20background&width=100&height=100&seq=avatar-02&orientation=squarish',
    time: '8分钟前',
    content: '编辑部速度真的快，刚在别的地方看到消息，这边已经有深度分析文章了，点赞！',
    likes: 218,
  },
  {
    user: '理性分析君',
    avatar: 'https://readdy.ai/api/search-image?query=Anonymous%20user%20avatar%20with%20glasses%20and%20thinking%20expression%2C%20warm%20minimal%20flat%20illustration%20style%2C%20clean%20design&width=100&height=100&seq=avatar-03&orientation=squarish',
    time: '15分钟前',
    content: '建议大家理性看待明星私生活，关注作品本身，但该吃的瓜一个都不能少哈哈。',
    likes: 187,
  },
  {
    user: '追星小能手',
    avatar: 'https://readdy.ai/api/search-image?query=Anonymous%20user%20avatar%20with%20star%20and%20heart%20icons%2C%20warm%20pink%20minimal%20flat%20illustration%20style%2C%20clean%20design&width=100&height=100&seq=avatar-04&orientation=squarish',
    time: '22分钟前',
    content: 'APP什么时候更新啊？希望能加个弹幕功能，边看瓜边吐槽才有意思！',
    likes: 156,
  },
  {
    user: '老瓜农',
    avatar: 'https://readdy.ai/api/search-image?query=Anonymous%20user%20avatar%20with%20retro%20vibe%20and%20warm%20orange%20tone%2C%20flat%20minimal%20illustration%20style%2C%20clean%20design&width=100&height=100&seq=avatar-05&orientation=squarish',
    time: '35分钟前',
    content: '吃了这么多年瓜，51吃瓜在线的深度和质量确实是最靠谱的，老粉了。',
    likes: 432,
  },
];

export const aboutInfo = {
  title: '关于51吃瓜在线',
  description1: '51吃瓜在线成立于2019年，是国内领先的娱乐资讯与吃瓜内容聚合平台。我们致力于为千万吃瓜群众提供最新、最全、最真实的娱乐爆料内容，涵盖明星动态、综艺追剧、网红圈、影视音乐等多个垂直领域。',
  description2: '平台汇聚了行业内资深编辑与内容创作者，坚持多源交叉验证的内容审核机制，在追求速度的同时绝不放弃对真实性的坚守。我们相信每一个"瓜"背后都有值得被讲述的故事。',
  stats: [
    { value: '5,000万+', label: '月活跃用户' },
    { value: '10万+', label: '日均内容更新' },
    { value: '50+', label: '合作媒体' },
    { value: '8年', label: '深耕行业' },
  ],
};

export const appInfo = {
  title: '随时随地 畅快吃瓜',
  description: '51吃瓜在线APP已全面上线，支持iOS与Android双平台。下载官方APP享受更流畅的浏览体验，开启推送通知不再错过任何一个热瓜。新用户注册即享7天VIP体验权益。',
  features: ['极速推送通知', '夜间模式护眼', '离线缓存阅读', '专属评论区表情包', '个性化瓜田订阅'],
  iosUrl: '#',
  androidUrl: '#',
};